module.exports = __webpack_public_path__ + "media/images/coming_soon-7b21c0e0.png";